import React from 'react'
import { useTheme } from '@mui/material'
import { FlexDiv } from '../components'

interface DesktopLayoutProps {
    children: React.ReactNode
}

export const DesktopLayout: React.FC<DesktopLayoutProps> = ({ children }) => {
    const theme = useTheme()

    return (
        <FlexDiv 
            direction="column" 
            style={{
                width: '100%',
                minHeight: '100vh',
                backgroundColor: theme.palette.background.default,
                padding: theme.spacing(2)
            }}
        >
            {children}
        </FlexDiv>
    )
} 